import { observer } from "mobx-react-lite";
import React, { useMemo } from "react";
import { useSingleton } from "../injection";
import { ErrorStore } from "./ErrorStore";
import { PopupContainer } from "../../uiLibrary/popup/popupContainer/PopupContainer";
import { NoticeDialog } from "../../uiLibrary/popup/noticeDialog/NoticeDialog";
import { Button } from "../../uiLibrary/button";

export const ErrorDisplay = observer(() => {
    const store = useSingleton(ErrorStore);

    const reloadClick = useMemo(
        () => () => {
            document.location.reload();
        },
        []
    );

    const details = useMemo(
        () =>
            store.errorMessage.split("\n").map((x, i) => (
                <React.Fragment key={i}>
                    {x}
                    <br />
                </React.Fragment>
            )),
        [store.errorMessage]
    );

    const isTimeout = !!store.errorItems.find(x => x.isTimeout);

    if (store.errorItems.length === 0) {
        return null;
    }

    const errorCode = store.errorItems.find(x => !!x.operation.code)?.operation
        .code;

    return (
        <PopupContainer zIndex={9999}>
            <NoticeDialog
                closeCallback={store.hideErrors}
                testId="errorDialog"
                title={
                    isTimeout ? "Timeout error" : "Sorry - something went wrong"
                }
                description="A report of the error has been sent to our support team."
                details={details}
                detailsShowLabel={
                    errorCode
                        ? `Show details (Error ${errorCode})`
                        : "Show details"
                }
                detailsHideLabel={
                    errorCode
                        ? `Hide details (Error ${errorCode})`
                        : "Hide details"
                }
                buttons={
                    <Button
                        onClick={reloadClick}
                        buttonType="neutral"
                        testId="reloadButton"
                    >
                        Reload this page
                    </Button>
                }
            />
        </PopupContainer>
    );
});
